__webpack_require__.p = "/study1c/";